import { WithEnterpriseId } from '@mews-commander/types';
import { useRepositoryQuery } from '@mews-commander/data-access';

export const useBestWesternIntegrationId = ({ enterpriseId }: WithEnterpriseId) => {
    const { data, isLoading } = useRepositoryQuery(
        'integrations',
        'getAllLoyalty',
        { enterpriseId },
        { select: (result) => ({ integrationId: result?.integrations?.[0]?.id }) }
    );

    return { integrationId: data?.integrationId, isLoading };
};
